import { useEffect, useState } from 'react';

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed bottom-8 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-lg text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
    >
      <i className="ri-arrow-up-line"></i>
    </button>
  );
}